module.exports = __webpack_public_path__ + "img/icon_delete.cb4ce4c9.svg";